import axiosDontWrapResultInstance, { handleResponseFulfilled, handleResponseRejected } from "./httpService"

export default {
    //serviceProxy调用axios.create()返回默认axiosDontWrapResultInstance实例
    create: () => axiosDontWrapResultInstance
}

export const getAxiosInstanceWithToken = (token: string) => {
    const instance = axiosDontWrapResultInstance.create();
    if (!!token) {
        instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }
    instance.defaults.headers.common['.AspNetCore.Culture'] = 'zh-Hans';
    instance.defaults.headers.common['Abp.TenantId'] = abp.multiTenancy.getTenantIdCookie() || '1';
    instance.interceptors.response.use(handleResponseFulfilled, handleResponseRejected);
    console.log(instance.interceptors);
    return instance;
}